<div class="demographic-update-container">
  <div class="demographic-update-content">
    <h1 class="iris-h1-responsive" data-test="header-demographic-update">We updated some of your insurance details</h1>
    <p class="iris-body-responsive">
      In order to process your claims smoothly, we updated some of your insurance details to match what we found {{ insuranceName }} has on file for you.
    </p>

    <div class="what-we-found-section">
      <h4 class="iris-h4-responsive what-we-found-title" data-test="header-what-we-found">What we found</h4>
      
      <div class="suggested-insurance-container">
        <div class="insurance-label" data-test="insurance-label">Insurance</div>
        <div
          class="insurance-name"
          data-test="insurance-name"
        >
          {{ suggestedInsuranceName }}
        </div>
        
        <div class="member-details-grid">
          <div class="member-detail-item">
            <div class="iris-body-responsive" data-test="member-name-label">Member name</div>
            <div class="iris-body-bold">
              <span [ngClass]="{'member-name-highlight': isNameDifferent}" data-test="member-name">{{ memberName }}</span>
            </div>
          </div>
          
          <div class="member-detail-item">
            <div class="iris-body-responsive" data-test="date-of-birth-label">Date of birth</div>
            <div class="iris-body-bold">
              <span [ngClass]="{'member-name-highlight': isDateOfBirthDifferent}" data-test="date-of-birth">{{ dateOfBirth }}</span>
            </div>
          </div>
          
          <div class="member-detail-item">
            <div class="iris-body-responsive" data-test="member-id-label">Member ID</div>
            <div class="iris-body-bold">
              <span [ngClass]="{'member-name-highlight': isMemberIdDifferent}" data-test="member-id">{{ memberId }}</span>
            </div>
          </div>
          
          <div class="member-detail-item">
            <div class="iris-body-responsive" data-test="group-number-label">Group number</div>
            <div class="iris-body-bold" data-test="group-number">{{ groupNumber }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="demographic-update-actions">
    <iris-button-container 
      [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
      [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
      <iris-button
        [type]="IrisButtonTypes.PRIMARY"
        [disabled]="processing"
        (click)="onContinueWithUpdatedInfo()"
        data-test="continue-with-updated-info-button"
      >
        @if (!processing) {
          Continue with updated info
        } @else {
          <mat-spinner
            class="button-spinner"
            diameter="24"
            aria-label="Processing update"
          ></mat-spinner>
        }
      </iris-button>
    </iris-button-container>

    <div class="support-info">
      <iris-icon 
        class="info-icon" 
        name="info"
        colorToken="$color-neutral-60"
        [size]="IconSizes.SM">
      </iris-icon>
      <span class="support-text">
        If this is not correct or you need help, 
        <a 
          [href]="supportContactUrl" 
          class="support-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          reach out to our support team
        </a>
        and we'll help verify your insurance.
      </span>
    </div>
  </div>
</div> 